import { createAction } from '@reduxjs/toolkit';
// Actions moved to separate file due to circular dependencies
export const forceLogout = createAction('auth/forceLogout');
export const tokenReceived = createAction('auth/tokenReceived');
